import { brand, surface, text } from '@vuelto/tokens';
import { ticketColors } from '../../shared/theme/ticketColors';

/**
 * Visual tokens alineados a @vuelto/tokens y al look de Catálogo.
 * Mantenemos la misma estructura de keys para no romper consumidores.
 */
export const agenda = {
  brand: brand[500],
  brandInk: text.onBrand,
  bg: surface.bg,
  surface: surface.surface,
  surface2: surface.surfaceSecondary,
  ink: text.primary,
  ink2: text.secondary,
  ink3: text.muted,
  border: surface.borderSoft,
  borderControl: surface.borderControl,
  chooseBg: brand[50],
  chooseBgHover: brand[100],
  chooseInk: brand[700],
  chooseBorder: brand[100],
  now: '#E11D48',
  slotClosed: 'rgba(0,0,0,0.035)',
  slotHover: ticketColors.brandSoft,
  hourLine: 'rgba(26,31,30,0.18)',
  requested: { bg: '#FFF4D6', border: '#E6B800', text: '#5C4A00' },
  confirmed: { bg: '#E7F3FF', border: '#3B82C4', text: '#163A5C' },
  completed: { bg: '#E8F5E9', border: '#4CAF50', text: '#1B5E20' },
  cancelled: { bg: surface.surfaceSecondary, border: surface.borderSoft, text: text.secondary },
  noShow: { bg: '#FDE8E8', border: '#CC4444', text: '#7A1212' },
  /** Proto: --slot-h: 22px per 15 min */
  slotH: 22,
  gutter: 56,
  headerH: 44,
  radius: 9,
  radiusBlock: 7,
  /** Card blanca Square (paridad con `ticketSurfaces.paperSheet`). */
  paperRadius: 14,
} as const;

/** Estilo canónico de card/panel en Agenda (= PaperSheet, tokens agenda). */
export const agendaPaperSheet = {
  backgroundColor: agenda.surface,
  borderWidth: 1,
  borderColor: agenda.border,
  borderRadius: agenda.paperRadius,
  overflow: 'hidden' as const,
};

export const agendaFonts = {
  sans: '"Plus Jakarta Sans", system-ui, sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, monospace',
} as const;

/** Fallback dots when resource.color is null — same spirit as the HTML proto. */
export const AGENDA_DOT_FALLBACKS = [
  ticketColors.gold,
  '#2563EB',
  '#A21CAF',
  '#C2410C',
  '#0E7490',
  '#B45309',
  '#4D7C0F',
  '#BE123C',
  '#4338CA',
  '#047857',
] as const;

export function agendaDotColor(color: string | null | undefined, index: number): string {
  if (color && /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color)) return color;
  return AGENDA_DOT_FALLBACKS[index % AGENDA_DOT_FALLBACKS.length]!;
}
